import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=10c9d426"
import script from "./ThemeSelector.vue?vue&type=script&lang=js"
export * from "./ThemeSelector.vue?vue&type=script&lang=js"
import style0 from "./ThemeSelector.vue?vue&type=style&index=0&id=10c9d426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports